module.exports = __webpack_public_path__ + "static/media/coach-sophie.6eb1cdb8.png";